import { render, staticRenderFns } from "./WindowCount.vue?vue&type=template&id=1f4b4e88"
import script from "./WindowCount.vue?vue&type=script&lang=ts"
export * from "./WindowCount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports